import { create } from 'zustand';

import type {
  EditingLabelBoxStoreAction,
  EditingLabelBoxStoreState,
} from '@/type';

const useEditingLabelBoxStore = create<
  EditingLabelBoxStoreState & EditingLabelBoxStoreAction
>((set, get) => ({
  isResizing: false,
  isRotating: false,
  isMoving: false,
  sizeOffset: [0, 0, 0],
  moveOffset: [0, 0, 0],
  rotationX: null,
  rotationY: null,
  rotationZ: null,

  isTransforming: false,
  transformedBoxData: {
    position: [0, 0, 0],
    dimension: [1, 1, 1],
    quaternion: [0, 0, 0, 0],
  },
  setIsResizing: isResizing => {
    set({
      isResizing,
    });
  },
  setIsRotating: isRotating => {
    set({
      isRotating,
    });
  },
  setIsMoving: isMoving => {
    set({
      isMoving,
    });
  },
  setSizeOffset: sizeOffset => {
    set({
      sizeOffset,
    });
  },
  setMoveOffset: offset => {
    set({
      moveOffset: offset,
    });
  },
  setRotationX: rotationX => {
    set({
      rotationX,
    });
  },
  setRotationY: rotationY => {
    set({
      rotationY,
    });
  },
  setRotationZ: rotationZ => {
    set({
      rotationZ,
    });
  },
  setIsTransforming(isTransforming) {
    set({
      isTransforming,
    });
  },
  updateTransformedBoxData({ position, dimension, quaternion }) {
    set({
      transformedBoxData: {
        position: position ?? get().transformedBoxData.position,
        dimension: dimension ?? get().transformedBoxData.dimension,
        quaternion: quaternion ?? get().transformedBoxData.quaternion,
      },
    });
  },
  getIsEditing() {
    return (
      get().isResizing ||
      get().isRotating ||
      get().isMoving ||
      get().isTransforming
    );
  },
  clear: () =>
    set({
      isResizing: false,
      isRotating: false,
      isMoving: false,
      sizeOffset: [0, 0, 0],
      moveOffset: [0, 0, 0],
      rotationX: null,
      rotationY: null,
      rotationZ: null,
      isTransforming: false,
      transformedBoxData: {
        position: [0, 0, 0],
        dimension: [1, 1, 1],
        quaternion: [0, 0, 0, 0],
      },
    }),
}));

export default useEditingLabelBoxStore;
